/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
	AssociateResourcesWithClient,
	AssociatedClientsForResourcesResponse,
	ClientEntityResponse,
	GetAssociatedClientsForResources,
	RemoveAssociations,
} from '../models/index';
import {
	AssociateResourcesWithClientFromJSON,
	AssociateResourcesWithClientToJSON,
	AssociatedClientsForResourcesResponseFromJSON,
	AssociatedClientsForResourcesResponseToJSON,
	ClientEntityResponseFromJSON,
	ClientEntityResponseToJSON,
	GetAssociatedClientsForResourcesFromJSON,
	GetAssociatedClientsForResourcesToJSON,
	RemoveAssociationsFromJSON,
	RemoveAssociationsToJSON,
} from '../models/index';

export interface AssociateResourcesWithClientRequest {
	encodedClientRID: string;
	xBffCsrf?: string;
	preservePreviousAssociation?: boolean;
	associateResourcesWithClient?: AssociateResourcesWithClient;
}

export interface GetAssociatedClientsForResourcesRequest {
	xBffCsrf?: string;
	getAssociatedClientsForResources?: GetAssociatedClientsForResources;
}

export interface RemoveAssociationsRequest {
	xBffCsrf?: string;
	removeAssociations?: RemoveAssociations;
}

/**
 * TaggingApi - interface
 *
 * @export
 * @interface TaggingApiInterface
 */
export interface TaggingApiInterface {
	/**
	 * Calls the tagging service and create a tag to associate one or more resources with client entity. Deletes previous association with any other client by default, unless preservePreviousAssociation is set to true.
	 * @summary Associate one or more resource with a client entity through tagging
	 * @param {string} encodedClientRID
	 * @param {string} [xBffCsrf]
	 * @param {boolean} [preservePreviousAssociation]
	 * @param {AssociateResourcesWithClient} [associateResourcesWithClient] Payload containing resources to associate with the client
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof TaggingApiInterface
	 */
	associateResourcesWithClientRaw(
		requestParameters: AssociateResourcesWithClientRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ClientEntityResponse>>;

	/**
	 * Calls the tagging service and create a tag to associate one or more resources with client entity. Deletes previous association with any other client by default, unless preservePreviousAssociation is set to true.
	 * Associate one or more resource with a client entity through tagging
	 */
	associateResourcesWithClient(
		requestParameters: AssociateResourcesWithClientRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ClientEntityResponse>;

	/**
	 * Get the client entities associated with the provided resource Ids
	 * @summary Get the client entities associated with the provided resource Ids
	 * @param {string} [xBffCsrf]
	 * @param {GetAssociatedClientsForResources} [getAssociatedClientsForResources] Payload containing resources Ids to get the clients
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof TaggingApiInterface
	 */
	getAssociatedClientsForResourcesRaw(
		requestParameters: GetAssociatedClientsForResourcesRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<AssociatedClientsForResourcesResponse>>;

	/**
	 * Get the client entities associated with the provided resource Ids
	 * Get the client entities associated with the provided resource Ids
	 */
	getAssociatedClientsForResources(
		requestParameters: GetAssociatedClientsForResourcesRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<AssociatedClientsForResourcesResponse>;

	/**
	 * Remove association of each of the provided resources with all of the provided clients. This is done by deleting the tags associated with the resources.
	 * @summary Remove association with clients
	 * @param {string} [xBffCsrf]
	 * @param {RemoveAssociations} [removeAssociations] Payload containing resources to remove the association with multiple clients
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof TaggingApiInterface
	 */
	removeAssociationsRaw(
		requestParameters: RemoveAssociationsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>>;

	/**
	 * Remove association of each of the provided resources with all of the provided clients. This is done by deleting the tags associated with the resources.
	 * Remove association with clients
	 */
	removeAssociations(
		requestParameters: RemoveAssociationsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void>;
}

/**
 *
 */
export class TaggingApi extends runtime.BaseAPI implements TaggingApiInterface {
	/**
	 * Calls the tagging service and create a tag to associate one or more resources with client entity. Deletes previous association with any other client by default, unless preservePreviousAssociation is set to true.
	 * Associate one or more resource with a client entity through tagging
	 */
	async associateResourcesWithClientRaw(
		requestParameters: AssociateResourcesWithClientRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ClientEntityResponse>> {
		if (
			requestParameters.encodedClientRID === null ||
			requestParameters.encodedClientRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedClientRID',
				'Required parameter requestParameters.encodedClientRID was null or undefined when calling associateResourcesWithClient.'
			);
		}

		const queryParameters: any = {};

		if (requestParameters.preservePreviousAssociation !== undefined) {
			queryParameters['preservePreviousAssociation'] =
				requestParameters.preservePreviousAssociation;
		}

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
				]
			);
		}

		const response = await this.request(
			{
				path: `/clients/{encodedClientRID}/associateResourcesWithClient`.replace(
					`{${'encodedClientRID'}}`,
					encodeURIComponent(String(requestParameters.encodedClientRID))
				),
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
				body: AssociateResourcesWithClientToJSON(
					requestParameters.associateResourcesWithClient
				),
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, jsonValue =>
			ClientEntityResponseFromJSON(jsonValue)
		);
	}

	/**
	 * Calls the tagging service and create a tag to associate one or more resources with client entity. Deletes previous association with any other client by default, unless preservePreviousAssociation is set to true.
	 * Associate one or more resource with a client entity through tagging
	 */
	async associateResourcesWithClient(
		requestParameters: AssociateResourcesWithClientRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ClientEntityResponse> {
		const response = await this.associateResourcesWithClientRaw(
			requestParameters,
			initOverrides
		);
		return await response.value();
	}

	/**
	 * Get the client entities associated with the provided resource Ids
	 * Get the client entities associated with the provided resource Ids
	 */
	async getAssociatedClientsForResourcesRaw(
		requestParameters: GetAssociatedClientsForResourcesRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<AssociatedClientsForResourcesResponse>> {
		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
				]
			);
		}

		const response = await this.request(
			{
				path: `/clients/getAssociatedClients`,
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
				body: GetAssociatedClientsForResourcesToJSON(
					requestParameters.getAssociatedClientsForResources
				),
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, jsonValue =>
			AssociatedClientsForResourcesResponseFromJSON(jsonValue)
		);
	}

	/**
	 * Get the client entities associated with the provided resource Ids
	 * Get the client entities associated with the provided resource Ids
	 */
	async getAssociatedClientsForResources(
		requestParameters: GetAssociatedClientsForResourcesRequest = {},
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<AssociatedClientsForResourcesResponse> {
		const response = await this.getAssociatedClientsForResourcesRaw(
			requestParameters,
			initOverrides
		);
		return await response.value();
	}

	/**
	 * Remove association of each of the provided resources with all of the provided clients. This is done by deleting the tags associated with the resources.
	 * Remove association with clients
	 */
	async removeAssociationsRaw(
		requestParameters: RemoveAssociationsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>> {
		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
				]
			);
		}

		const response = await this.request(
			{
				path: `/clients/removeAssociations`,
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
				body: RemoveAssociationsToJSON(requestParameters.removeAssociations),
			},
			initOverrides
		);

		return new runtime.VoidApiResponse(response);
	}

	/**
	 * Remove association of each of the provided resources with all of the provided clients. This is done by deleting the tags associated with the resources.
	 * Remove association with clients
	 */
	async removeAssociations(
		requestParameters: RemoveAssociationsRequest = {},
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void> {
		await this.removeAssociationsRaw(requestParameters, initOverrides);
	}
}
